import React, { createContext, useState, useEffect, useContext } from 'react';

// Création du contexte
export const AuthContext = createContext();

// Hook personnalisé pour utiliser le contexte d'authentification
export const useAuth = () => useContext(AuthContext);

// Fournisseur du contexte d'authentification
export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Vérifier l'état d'authentification depuis localStorage au chargement
  useEffect(() => {
    const checkAuth = () => {
      setIsLoading(true);
      
      const authStatus = localStorage.getItem('isAuthenticated') === 'true';
      const authExpiry = localStorage.getItem('authExpiry');
      const username = localStorage.getItem('username');
      
      // Vérifier si l'authentification a expiré
      if (authStatus && authExpiry) {
        const expiry = new Date(authExpiry);
        if (expiry < new Date()) {
          // Si expiré, nettoyer l'authentification
          logout();
          setIsLoading(false);
          return;
        }
      }
      
      setIsAuthenticated(authStatus);
      setUsername(username);
      setIsLoading(false);
    };
    
    checkAuth();
  }, []);

  // Fonction de connexion
  const login = (username) => {
    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('username', username);
    
    // Date d'expiration (24h)
    const expiry = new Date();
    expiry.setHours(expiry.getHours() + 24);
    localStorage.setItem('authExpiry', expiry.toISOString());
    
    setIsAuthenticated(true);
    setUsername(username);
  };

  // Fonction de déconnexion
  const logout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('authExpiry');
    localStorage.removeItem('username');
    
    setIsAuthenticated(false);
    setUsername(null);
  };

  // Valeurs à fournir au contexte
  const authContextValue = {
    isAuthenticated,
    username,
    isLoading,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={authContextValue}>
      {children}
    </AuthContext.Provider>
  );
};